// extracted by mini-css-extract-plugin
export default {"loading":"_3zKpe","product":"Xffr2"};